"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleContainer = void 0;
exports.mapStateToProps = mapStateToProps;
exports.mergeProps = mergeProps;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _selectors = require("./selectors");
var _TitleContainer = require("./TitleContainer");
var _reactRedux = require("react-redux");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function mapStateToProps(state) {
  return {
    currentView: (0, _selectors.activeViewSelector)(state),
    viewData: (0, _selectors.viewDataSelector)(state),
    flow: (0, _selectors.activeFlowSelector)(state)
  };
}
function mergeProps(stateProps, _dispatchProps, ownProps) {
  return _objectSpread(_objectSpread({}, stateProps), ownProps);
}
const TitleContainer = exports.TitleContainer = (0, _reactRedux.connect)(mapStateToProps, null, mergeProps)(_TitleContainer.TitleContainer);